/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsFilter: {
  name: 'filter';
  data: string;
} = {
  name: 'filter',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.951 5.971C4.211 4.638 5.175 3 6.7 3h10.6c1.526 0 2.49 1.638 1.749 2.971L15 13.26V18c0 1.648-1.882 2.589-3.2 1.6l-2-1.5a2 2 0 0 1-.8-1.6v-3.24L4.951 5.97ZM6.7 5l4.048 7.288a2 2 0 0 1 .252.971V16.5l2 1.5v-4.74a2 2 0 0 1 .252-.972L17.3 5H6.7Z" fill="currentColor"/></svg>`,
};
